import { api, errMsg } from "./api";
import { toast } from "sonner";

let snapLoading = null;

function loadSnapScript(clientKey, baseUrl) {
  if (window.snap) return Promise.resolve();
  if (snapLoading) return snapLoading;
  snapLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `${baseUrl}/snap/snap.js`;
    s.setAttribute("data-client-key", clientKey);
    s.onload = resolve;
    s.onerror = () => reject(new Error("Gagal memuat Midtrans Snap"));
    document.body.appendChild(s);
  });
  return snapLoading;
}

export async function paySaleWithMidtrans(sale, customerName, onDone) {
  try {
    const { data } = await api.post("/payments/snap-token", {
      sale_id: sale.id, customer_name: customerName || sale.customer || "Pelanggan",
    });
    await loadSnapScript(data.client_key, data.base_url);
    window.snap.pay(data.token, {
      onSuccess: () => { toast.success("Pembayaran berhasil!"); onDone?.(); },
      onPending: () => { toast.info("Menunggu pembayaran (QRIS/VA)..."); onDone?.(); },
      onError: () => { toast.error("Pembayaran gagal"); onDone?.(); },
      onClose: () => onDone?.(),
    });
  } catch (e) {
    toast.error(errMsg(e));
    onDone?.();
  }
}
